import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import React, { useState, createContext, useEffect } from "react"

export const DiagnosticEducatifContext = createContext({
    fetchingDiagEduc: false,
    setFetchingDiagEduc: () => {},

    updateEducationalDiagnosis: false,
    setUpdateEducationalDiagnosis: () => {},

    educationalDiagnosisList: [],
    setEducationalDiagnosisList: () => {},

    redirectToList: false,
    setRedirectToList: () => {},

    axisLastItemIndex: 0,
    setAxisLastItemIndex: () => {}
})

export default function DiagnosticEducatifProvider(props) {
    const { children } = props
    const [fetchingDiagEduc, setFetchingDiagEduc] = useState(false)
    const [hasEducationalDiagnosis, setHasEducationalDiagnosis] = useState(false)
    const [updateEducationalDiagnosis, setUpdateEducationalDiagnosis] = useState(false)
    const [educationalDiagnosisList, setEducationalDiagnosisList] = useState([])
    const [redirectToList, setRedirectToList] = useState(false)
    const [axisLastItemIndex, setAxisLastItemIndex] = useState(0)

    useEffect(() => {
        setHasEducationalDiagnosis(() => {
            if (
                educationalDiagnosisList?.length > 0 &&
                educationalDiagnosisList?.find((item) => item.diagnosisStatus.code === "diagnosis_finished")
            ) {
                return true
            }
            return false
        })
    }, [educationalDiagnosisList])

    LocalStorage.getFirstTimeDEVisitingStatus().then((status) => {
        if (status === true) {
            setRedirectToList(status)
        }
    })

    return (
        <DiagnosticEducatifContext.Provider
            value={{
                fetchingDiagEduc,
                setFetchingDiagEduc,

                updateEducationalDiagnosis,
                setUpdateEducationalDiagnosis,

                educationalDiagnosisList,
                setEducationalDiagnosisList,

                redirectToList,
                setRedirectToList,

                hasEducationalDiagnosis,

                axisLastItemIndex,
                setAxisLastItemIndex
            }}
        >
            {children}
        </DiagnosticEducatifContext.Provider>
    )
}
